import { createApp } from "vue";
import App from "./AppPost.vue";

document.addEventListener("DOMContentLoaded", () => {
  const postArea = document.getElementById('js-app');
  const commentsArea = document.getElementById('js-comments');
  const commentPostArea = document.getElementById('js-post-comment');

  // テレポート先の PHP 描画内容をクリア（Vue の追記で重複しないようにする）
  if (commentsArea) {
    commentsArea.textContent = '';
  }
  if (commentPostArea) {
    commentPostArea.textContent = '';
  }

  if (postArea) {
    const app = createApp(App);
    app.provide('postId', Number(postArea.dataset.postId));
    app.provide('userId', Number(postArea.dataset.userId));
    app.mount(postArea);
  }
});
